/**
 * Start SizeとEnd Sizeをnumeric stringで受け取って、
 * 寸法クエリの形（[2020-02-20 to +]など）に整形して返す
 * @param start: numeric string | empty string
 * @param end: numeric string | empty string
 * @returns query: string
 */
const getSizeQuery = (start: string, end: string): string => {
  if (start === '' && end === '') {
    return '';
  } else if ((start !== '' && end === '') || (start === '' && end !== '')) {
    return start !== '' ? start : end;
  } else {
    const query: string = '[' + start + ' TO ' + end + ']';
    return query;
  }
};

export default getSizeQuery;
